<template>
	<div class="search-page blue-hoki" v-if="numPages !== 0">
		<div class="search-pagination pagination-rounded">
			<ul class="pagination">
				<li class="page-pre" :class="{'disabled': activePage === 1}">
					<a class="fa fa-angle-left" @click="setActivePage(activePage - 1)"></a>
				</li>
				<li class="page-number" :class="{'active': activePage === 1}">
					<a @click="setActivePage(1)">1</a>
				</li>
				<li v-if="activePage !== 1 && activePage !== 2 && activePage !== 3"><a class="pagination-ellipsis">. . .</a></li>
				<li v-for="(page, index) in pagesArray" class="page-number" :class="{'active': activePage === page}" v-if="showPageIndex(index)">
					<a @click="setActivePage(page)">{{ page }}</a>
				</li>
				<li v-if="activePage !== pagesArray.length && activePage !== pagesArray.length - 1 && activePage !== pagesArray.length - 2"><a class="pagination-ellipsis">. . .</a></li>
				<li class="page-number" :class="{'active': activePage === pagesArray.length}" v-if="numPages !== 1">
					<a @click="setActivePage(pagesArray.length)">{{ pagesArray.length }}</a>
				</li>
				<li class="page-next" :class="{'disabled': activePage === numPages}">
					<a class="fa fa-angle-right" @click="setActivePage(activePage + 1)"></a>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
/**
 * Pagination module is used to control the pagination for a list of results.
 * @class Pagination
 * @prop {integer} numPages - Used to determine the total number of pages
 * @prop {integer} passedPage - Used to determine the page being passed into the component as active
 * @since 0.0.3
 */

export default {
	name: 'pagination',
	props: {
		numPages: {
			default: 1
		},
		passedPage: {}
	},
	data () {
		return {
			activePage: 1
		}
	},
	/**
	 * Run on `created` to set the active page as the value passed in.
	 * @function
	 * @returns {undefined}
	 * @memberof Pagination
	 * @version 0.0.4
	 */
	created () {
		if (this.passedPage) {
			if (this.passedPage <= this.numPages) {
				if (this.activePage !== this.passedPage) {
					this.activePage = this.passedPage
				}
			} else {
				this.activePage = 1
			}
		}
	},
	/**
	 * Run on `updated` to set the active page as the value passed in. Mainly used to reset the pagination to the first page when something on the parent prompts it.
	 * @function
	 * @returns {undefined}
	 * @memberof Pagination
	 * @version 0.0.4
	 */
	updated () {
		if (this.passedPage) {
			if (this.passedPage <= this.numPages) {
				if (this.activePage !== this.passedPage) {
					this.activePage = this.passedPage
				}
			} else {
				this.activePage = 1
			}
		}
	},
	computed: {
		/**
		 * Computed to create an array of numbers based on the number of pages.
		 * @function
		 * @returns {array} - An array of numbers counting from 1 up to the total number of pages.
		 * @memberof Pagination
	 	 * @version 0.0.4
		 */
		pagesArray () {
			let localPagesArray = []
			for (let i = 1, x = this.numPages; i <= x; i++) {
				localPagesArray.push(i)
			}
			return localPagesArray
		}
	},
	methods: {
		/**
		 * To set the active page.
		 * @function
		 * @param {integer} page - An integer representing the page that is we are setting as active.
		 * @returns {undefined}
		 * @memberof Pagination
	 	 * @version 0.0.4
		 */
		setActivePage (page) {
			if (page !== this.activePage && page !== 0 && page <= this.numPages) {
				this.activePage = page
				this.emitActivePage()
			}
		},
		/**
		 * To emit the updated active page to the parent.
		 * @function
		 * @returns {undefined}
		 * @memberof Pagination
	 	 * @version 0.0.4
		 */
		emitActivePage () {
			this.$emit('activePageChange', this.activePage)
		},
		/**
		 * To limit the number of page options that are displaying.
		 * @function
		 * @param {integer} index - An integer representing the page that is being filtered.
		 * @returns {undefined}
		 * @memberof Pagination
	 	 * @version 0.0.4
		 */
		showPageIndex (index) {
			// Make sure that the first and last page never show in this list
			if (index === 0 || index === this.pagesArray.length - 1) {
				return false
			}

			// Show the current active page
			if (index === this.activePage - 1) {
				return true
			}

			// Show the previous page and next page
			if (index === this.activePage - 2 || index === this.activePage) {
				return true
			}

			return false
		}
	}
}
</script>
<style>
.search-page .search-pagination>.pagination>.page-next>a, .search-page .search-pagination>.pagination>.page-pre>a {
	margin-top: 3px;
	width: 26px;
    text-align: center;
    padding: 6px;
}

/* Temporary color overrides - this will be moved to unoapp.css */
.blue-hoki.search-page .search-pagination>.pagination>li>a:hover {
	color: #fff;
	background-color: #67809F;
    border-color: #67809F;
}
.blue-hoki.search-page .pagination>.active>a, .blue-hoki.search-page .pagination>.active>a:focus, .blue-hoki.search-page .pagination>.active>a:hover, .blue-hoki.search-page .pagination>.active>span, .blue-hoki.search-page .pagination>.active>span:focus, .blue-hoki.search-page .pagination>.active>span:hover {
	color: #fff;
	background-color: #67809F;
    border-color: #67809F;
}
.search-page .search-pagination>.pagination>li>a.pagination-ellipsis {
	background-color: transparent;
	padding: 12px 6px 0px;
}
</style>


// WEBPACK FOOTER //
// Pagination.vue?bed227b6